export default __webpack_public_path__ + "assets/images/d46fea7d88f7e0932b33dc0eb2679bc2.svg";